import { useEffect } from "react";
import localRepository from "../../../localRepository";
import { useSelector, useDispatch } from "react-redux";
import { useAuth0 } from "../../Auth0/useAuth";
import { postOnboarding } from "../../auth/actions";

interface OnboardingSlice {
  isOnboardingDone: boolean;
  isValidating: boolean;
}

const useReduxSelector = () =>
  useSelector<any, OnboardingSlice>((state) => ({
    isOnboardingDone: state.authReducer.validated,
    isValidating: state.authReducer.validating,
  }));

const usePostOnboarding = (): void => {
  const token = localRepository.accessToken.get();
  const { isOnboardingDone, isValidating } = useReduxSelector();

  const dispatch = useDispatch();
  const { authState } = useAuth0();

  useEffect(() => {
    // Read isLoggedIn from localStorage at effect time so we observe the
    // value setSession wrote during the just-completed callback flow,
    // instead of a stale snapshot captured before parseHash ran.
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    const userRequiresOnboarding =
      token &&
      ((authState.user && !authState.user.isAuthorized) || !isLoggedIn);

    if (userRequiresOnboarding && !isOnboardingDone && !isValidating) {
      // Do NOT call renewSession here: the user just authenticated, the
      // token is fresh, and silent renewal via checkSession routinely
      // fails on localhost / under 3rd-party-cookie restrictions, which
      // would cascade into logout() right after the home page renders.
      dispatch(postOnboarding() as any);
    }
  }, [dispatch, authState, token, isOnboardingDone, isValidating]);
};

export default usePostOnboarding;
